module.exports = __webpack_public_path__ + "static/img/icon-change-password.ac6d910.png";